p:first-child{margin-top:0}form{position:relative;overflow:hidden}form .content{max-width:70%;line-height:24px}form img{width:200px;max-width:270px;height:130px;position:absolute;top:20px;right:-40px}
/*# sourceMappingURL=dump-demo-data.component-XJTRRCKC.css.map */
